import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem } from '@material-ui/core'


export default function StaffSelect({ staffList = [], onStaffSelected = () => { }, initialValue = null }) {
    const [val, setVal] = useState('');

    useEffect(() => {
        setVal(initialValue || '');
    }, [initialValue])

    const selectStaff = (e) => {
        const selectedId = e.target.value;
        setVal(selectedId);
        const staff = staffList.find((s) => s.id === selectedId)
        if (staff) {
            onStaffSelected(staff);
        }
    }

    return (
        <FormControl fullWidth>
            <Select
                id="demo-simple-select"
                value={val}
                label="Owner"
                onChange={(e) => selectStaff(e)}
            >
                {staffList.map(s => (<MenuItem id={s.id} value={s.id}>{s.name}</MenuItem>))}
            </Select>
        </FormControl>

    )
}
